import mutations from "mutations"
import queries from "queries"
import typeDefs from "typeDefs"

export { mutations, queries, typeDefs }
